const faqs = [
  {
    id: 1,
    q: '吃瓜黑料爆料是一个什么样的平台？',
    a: '吃瓜黑料爆料是国内领先的娱乐八卦爆料讨论社区，汇聚全网吃瓜群众，提供最新娱乐八卦小道消息、明星爆料、综艺争议、网红内幕等热门内容。我们致力于打造一个自由、真实的吃瓜交流平台，让每一位瓜友都能第一时间吃到最新鲜的瓜。',
  },
  {
    id: 2,
    q: '如何爆料投稿？会保护我的隐私吗？',
    a: '你可以通过本页面的"联系我们"区域找到投稿方式。我们严格保护每一位爆料者的隐私安全，采用多层匿名加密技术，绝不向任何第三方透露爆料者身份信息。投稿后我们的审核团队会在24小时内完成内容审核。',
  },
  {
    id: 3,
    q: '平台上的内容可信度如何保证？',
    a: '我们建立了严格的内容审核机制：所有爆料帖需经过AI初审+人工复核双重把关，同时社区举报机制让虚假信息无处遁形。对于存疑内容，我们会在标题和正文中明确标注"待验证"标签。我们始终建议瓜友们理性吃瓜。',
  },
  {
    id: 4,
    q: '如何参与社区讨论和互动？',
    a: '目前平台处于公测阶段，你可以浏览所有公开内容并对帖子进行点赞和分享。评论功能和用户注册系统即将上线，届时你将可以发表评论、收藏帖子、关注感兴趣的话题板块，获得更完整的社区体验。',
  },
  {
    id: 5,
    q: '遇到侵权或虚假信息怎么办？',
    a: '如果你发现平台内容侵犯了你的合法权益或存在明显虚假信息，可以通过"联系我们"区域提交侵权投诉或内容举报。我们的法务团队会在收到申请后48小时内进行核实处理，确认真实后会立即下架相关内容。',
  },
  {
    id: 6,
    q: '平台有移动端APP吗？在哪里下载？',
    a: '有的！我们为瓜友们精心打造了移动端APP，提供更便捷的浏览体验和实时推送通知。你可以在本页面的"APP下载"区域找到下载入口，支持iOS和Android双平台，让你随时随地吃瓜不停。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              常见问题
            </h2>
            <p className="text-sm text-foreground-500">关于吃瓜黑料爆料，你想知道的都在这里</p>
          </div>
          <div className="space-y-3">
            {faqs.map((faq) => (
              <details
                key={faq.id}
                className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden"
                open
              >
                <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                  <h3 className="text-sm font-semibold text-foreground-800 pr-4">{faq.q}</h3>
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 text-foreground-400 group-open:text-primary-500 transition-colors">
                    <i className="ri-arrow-down-s-line group-open:rotate-180 transition-transform duration-200"></i>
                  </div>
                </summary>
                <div className="px-5 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}